import { render } from "./App.vue?vue&type=template&id=2e3727d3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2e3727d3&lang=scss"

import exportComponent from "D:\\svn\\RD\\code\\Branches\\ZWV2.4.0\\V3.0.0\\hiwoo-cloud\\cloud-pedestal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__